import React, { useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import AuthContext from '../../context/auth/authContext';
import TopNavbar from '../nav/TopNav';
import styled from 'styled-components';
import './CreateAccount.css';

const StyledBurger = styled.div`
  .btn-block {
    background: var(--primary-color);
    color: var(--black-color);
    border: 1.5px solid var(--black-color);
  }
`;

const CreateAccount = () => {
  const authContext = useContext(AuthContext);

  const { register } = authContext;

  const [user, setUser] = useState({
    firstname: '',
    lastname: '',
    email: '',
    password: '',
  });

  const { firstname, lastname, email, password } = user;

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    register({
      firstname: '',
      lastname: '',
      email: '',
      password: '',
    });
  };
  return (
    <StyledBurger>
      <div className='Accounts-bg'>
        <TopNavbar />

        <div className='form_block'>
          <div className='form_block--sub'>
            <div className='form_block--heading'>
              <p>Create an Account</p>
            </div>
            <div>
              <form onSubmit={onSubmit}>
                <div className='form-input-name'>
                  <div className='form-input-firstname'>
                    <label htmlFor='firstname'>First name</label>
                    <input
                      type='text'
                      name='firstname'
                      value={firstname}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div className='form-input-lastname'>
                    <label htmlFor='lastname'>Last name</label>
                    <input
                      type='text'
                      name='lastname'
                      value={lastname}
                      onChange={onChange}
                      required
                    />
                  </div>
                </div>{' '}
                <div className='form-input-email'>
                  <label htmlFor='email'>Email address</label>
                  <input
                    type='email'
                    name='email'
                    value={email}
                    onChange={onChange}
                    required
                  />
                </div>{' '}
                <div className='form-input-password'>
                  <label htmlFor='password'>Password</label>
                  <input
                    type='password'
                    name='password'
                    value={password}
                    onChange={onChange}
                    minLength='6'
                    required
                  />
                </div>
                <div className='form-input-submit'>
                  <button
                    type='submit'
                    value='Create Account'
                    className='btn btn-black'
                  >
                    Create Account
                  </button>
                </div>
              </form>
            </div>
            <div className='form_block--footer'>
              <div>
                <p>Already have an account?</p>
                <NavLink to='/login' className='btn btn-block'>
                  Sign in
                </NavLink>
              </div>
              <div>
                <NavLink to='/shipAddGuest' className='btn btn-block'>
                  Check Out as guest
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledBurger>
  );
};

export default CreateAccount;
